<template>
  <v-snackbar v-model="visible" color="surface" elevation="12">
    {{ text }}
    <template v-slot:actions>
      <v-btn color="warning" variant="text" @click="visible = false">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script lang="ts">
import { mapGetters } from 'vuex';
import { sleep } from '../utils/general'
import { Options, Vue } from 'vue-class-component'
import { SnackbarUpdate } from '@/store/global';

@Options({
  // props: {
  //   text: String
  // },
  computed: {
    ...mapGetters(['snackbar'])
  },
  watch: {
    snackbar(val: { text: string; timeout?: number }) {
      if (val != null && !this.visible) {
        const { text, timeout } = val
        this.text = text
        if (timeout != null) {
          this.timeout = timeout
        }
        this.showSnackbar()
      }
    }
  }
})
export default class Snackbar extends Vue {
  public text: string = ''
  public updateSnackbar!: SnackbarUpdate
  public timeout: number = 5_000
  public defaultTimeout: number = 5_000
  public visible: boolean = false

  public async showSnackbar() {
    this.visible = true
    await sleep(this.timeout)
  }

  public async reset() {
    this.visible = false
    this.timeout = this.defaultTimeout
    this.text = ''
  }
}
</script>
